import { __assign } from "tslib";
import { connect } from 'react-redux';
import uniqueId from 'lodash/uniqueId';
import { initialize } from './actionCreators';
import { getIsInitialized, getTooltipState } from './selectors';
import { getCurrentUser } from '../../publicSession/selectors';
import { startNewChatWithParticipant } from '../../ChatV2/redux/actions';
var mapStateToProps = function (state, ownProps) {
    var username = ownProps.username;
    var currentUser = getCurrentUser(state);
    return __assign({ isInitialized: getIsInitialized(state, username), isOwner: currentUser && currentUser.username === username }, getTooltipState(state, username));
};
var mapDispatchToProps = function (dispatch) { return ({
    initialize: function (username) { return dispatch(initialize(username)); },
    onStartChat: function (user) {
        return dispatch(startNewChatWithParticipant(uniqueId('new-chat-request'), {
            id: user.useridUuid,
            name: user.username,
        }));
    },
}); };
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=UserAvatarPopover.container.js.map